import React, { useState } from "react";

import AcordionCardSimulation from "../acordionCard/acordionCardSimulation";

import * as S from "./styles";

export function SimulationPlans() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [userCount, setUserCount] = useState(0);

  return (
    <S.ContainerContentSimulation>
      <AcordionCardSimulation
        onPlanSelected={setSelectedPlan}
        onUsersCountChanged={(value) => {
          if (selectedPlan?.label === "PLANO BASIC") {
            setUserCount(1);
          } else {
            setUserCount(value);
          }
        }}
        // isUserCountDisabled={selectedPlan?.label === "PLANO BASIC"}
      />
    </S.ContainerContentSimulation>
  );
}
